import 'components/modals/account_limit_free_modal';
import 'components/modals/account_not_confirm_modal';
import 'components/modals/login_register_modal';
import 'components/modals/question_belt_block_modal';
import 'components/modals/questions_limit_modal';
import 'components/modals/session_expired_modal';
import AccountLimitFreeModal from 'components/modals/account_limit_questions_modal';
import LoginRegister from 'utils/login_register';
import ModalManager from 'utils/modal_manager';
import NotSubscribedUserModal from 'components/modals/not_subscribed_user_modal';
import applyCountdown from 'utils/countdown';

const feedbacks = {
  utils: {
    block(event = new Event(null)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    },
    openModal(modal) {
      ModalManager.open(`#${modal}`);
    },
    getEventResourceLimitSlug(resource) {
      const eventSlug = {
        question_comments: 'question commentaries',
        question_statistics: 'question statistics',
        question_teacher: 'commented_feedback'
      };

      return eventSlug[resource];
    }
  },
  buildLimitModal: function (dataKey) {
    const modalSeletor = 'js-account-limit-free-modal';
    const $modalBody = $(`#${modalSeletor} .modal-content`);
    const data = $modalBody.data(dataKey);
    const imageFallback = $modalBody.data('imageFallback');

    $modalBody.find('a').attr('href', data.cta_link);

    $(`#${modalSeletor} .js-benefits-list`)
      .find('li p')
      .each(function (index) {
        $(this).html(data.args[index]);
      });

    if ($modalBody.find('[data-modal-image]')) {
      $modalBody
        .find('[data-modal-image]')
        .attr('src', data?.image ?? imageFallback);
    }

    this.createCloseModalEventProxy(modalSeletor, dataKey);

    ModalManager.populate(`#${modalSeletor}`, {
      username: currentUser.name,
      title: data.title,
      description: data.description,
      'btn-text': data.btn_text,
      'cta-text': data.cta_text
    });

    const $title = $(`#${modalSeletor} [data-title]`);

    if ($title.length > 0) {
      $title.attr('aria-label', data.title);
    }

    this.utils.openModal(modalSeletor);
    applyCountdown({
      selector: `#${modalSeletor} .countdown`,
      template: '%H:%M:%S'
    });
  },

  buildBlockQuestionBeltModal() {
    applyCountdown({
      selector: '#js-question-belt-block-modal .limit-countdown',
      template: '%H:%M:%S'
    });

    this.createCloseModalEventProxy('js-question-belt-block-modal');

    this.utils.openModal('js-question-belt-block-modal');
  },

  createCloseModalEventProxy(modalSelector, key) {
    $(`#${modalSelector}`)
      .off('hidden.bs.modal')
      .on('hidden.bs.modal', () => {
        const { showOnQuestionLimitation, showOnModalRestriction, active } =
          gon.flags.trial_settings;

        if (
          key === 'modal-questions-content' &&
          active &&
          showOnQuestionLimitation
        ) {
          window.openTrialModal('question_limitation');
        }

        if (
          modalSelector === 'js-question-belt-block-modal' &&
          active &&
          (showOnQuestionLimitation || showOnModalRestriction)
        ) {
          window.openTrialModal('question_limitation');
        }

        if (key === 'modal-restriction' && active && showOnModalRestriction) {
          window.openTrialModal('modal_restriction');
        }
      });
  },

  account(event, url = location.pathname, data) {
    LoginRegister.newLoginModal(url, data);
    this.utils.block(event);
  },

  confirmed_account(event) {
    this.utils.openModal('js-account-not-confirm-modal');
    this.utils.block(event);
  },

  createNotebookLimit(event) {
    this.buildLimitModal('modal-notebooks-content');

    this._sendAnalytics({ 'resource limited': 'notebooks' });
    this.utils.block(event);
  },

  practiceTestLimit(event) {
    this.buildLimitModal('modal-practice-tests-content');

    this._sendAnalytics({ 'resource limited': 'practice tests' });
    this.utils.block(event);
  },

  saveFilterLimit(event) {
    this.buildLimitModal('modal-stored-filters-content');

    this._sendAnalytics({ 'resource limited': 'stored filers' });
    this.utils.block(event);
  },

  resolveQuestionLimit(event) {
    this.buildLimitModal('modal-questions-content');

    this._sendAnalytics({ 'resource limited': 'questions' });
    this.utils.block(event);
  },

  viewCommentaryLimit(event) {
    this.buildLimitModal('modal-question-commentaries-content');

    this._sendAnalytics({ 'resource limited': 'question commentaries' });
    this.utils.block(event);
  },

  printQuestionsLimit(event) {
    this.buildLimitModal('modal-questions-print-content');

    this._sendAnalytics({ 'resource limited': 'question printing' });
    this.utils.block(event);
  },

  subscription(event) {
    const allowedEvents = ['per_page', 'sort', 'commented_feedback'];

    if (!allowedEvents.includes(event?.detail?.type)) {
      return;
    }
    new NotSubscribedUserModal(
      '#js-not-subscribed-user-modal',
      event.detail.type
    );

    this.createCloseModalEventProxy(
      'js-not-subscribed-user-modal',
      'modal-restriction'
    );

    this.utils.block(event);
  },

  trial(event) {
    const allowedEvents = ['commented_feedback'];

    if (!allowedEvents.includes(event?.detail?.type)) {
      return;
    }
    new NotSubscribedUserModal(
      '#js-not-subscribed-user-modal',
      event.detail.type
    );

    this.utils.block(event);
  },

  questionsLimitModal(event) {
    this.flexibleLimitModal(event, {
      title: 'Continue praticando!',
      description: 'Você está no ritmo certo para conquistar sua vaga',
      message:
        'Você chegou ao limite do plano gratuito, isso mostra o quanto você está <strong>comprometido com seu futuro</strong>.',
      resourceType: 'questions',
      ctaUrl:
        '/planos-de-assinatura?qtm_source=questions_odin&qtm_medium=intervencao&qtm_content=modal_limitacao&qtm_term=produto&qtm_campaign=plg'
    });
  },

  newQuestionLimitModal(event) {
    this.utils.openModal('js-account-limit-questions-modal');
    this._sendAnalytics({ 'resource limited': 'questions' });
    const newQuestionLimitModal = new AccountLimitFreeModal();
    newQuestionLimitModal.load();
    this.utils.block(event);
  },

  flexibleLimitModal(event, options = {}) {
    this.utils.openModal('js-questions-limit-modal');

    const $modal = $('#js-questions-limit-modal');

    if (options.title) {
      $modal.find('h1').html(options.title);
    }

    if (options.description) {
      $modal.find('p').eq(0).html(options.description);
    }

    if (options.message) {
      $modal.find('.js-modal-message').html(options.message);
    }

    if (options.ctaUrl) {
      $modal.find('#cta-questions-limit-modal').attr('href', options.ctaUrl);
    }

    if (options.resourceType) {
      this.customizeModalButtons($modal, options.resourceType);
    }

    this._sendAnalytics({
      'resource limited': options.resourceType || 'generic'
    });
    this.utils.block(event);
  },

  customizeModalButtons($modal, resourceType) {
    const buttonTexts = {
      'question commentaries': {
        cta: 'Desbloquear acesso ilimitado',
        link: 'Interromper ritmo de estudo'
      },
      'commented feedback': {
        cta: 'Desbloquear acesso ilimitado',
        link: 'Interromper ritmo de estudo'
      },
      'classes - question belt': {
        cta: 'Desbloquear acesso ilimitado',
        link: 'Interromper ritmo de estudo'
      },
      questions: {
        cta: 'Desbloquear acesso ilimitado',
        link: 'Interromper ritmo de estudo'
      }
    };

    const texts = buttonTexts[resourceType];

    if (texts) {
      $modal.find('.btn-primary').text(texts.cta);
      $modal.find('.btn-close').text(texts.link);
    }
  },

  questionBeltBlock() {
    this.buildBlockQuestionBeltModal();
    this._sendAnalytics({ 'resource limited': 'questions' });
    this.utils.block();
  },

  premium(event) {
    this.utils.openModal('js-not-premium-user-modal');
    this.utils.block(event);
  },

  premiumPlus(event) {
    this.utils.openModal('js-not-premium-plus-user-modal');
    this.utils.block(event);
  },

  black(event) {
    this.utils.openModal('js-not-black-user-modal');
    this.utils.block(event);
  },

  unlimited(event) {
    this.utils.openModal('js-not-unlimited-user-modal');
    this.utils.block(event);
  },

  digitalUnlimited(event) {
    this.utils.openModal('js-not-digital-unlimited-user-modal');
    this.utils.block(event);
  },

  questionBeltLimit(type) {
    this._sendAnalytics({
      'resource limited': this.utils.getEventResourceLimitSlug(type)
    });
    this.utils.block();
  },

  commented_feedback_enabled(event) {
    this.subscription(event);
    this._sendAnalytics({ 'resource limited': 'commented_feedback' });
  },

  commentsLimitModalSimple(event) {
    this.flexibleLimitModal(event, {
      title: 'Você atingiu o limite de comentários',
      description: 'Você está no ritmo certo para conquistar sua vaga',
      message:
        '<strong>Libere os comentários</strong> e veja o <strong>que a comunidade esta pensando</strong>, entendendo o <strong>porquê</strong> desse gabarito.',
      resourceType: 'question commentaries',
      ctaUrl:
        '/planos-de-assinatura?qtm_source=belt_comentarios_odin&qtm_medium=intervencao&qtm_content=modal_limitacao&qtm_term=produto&qtm_campaign=plg'
    });
  },

  questionTeacherLimitModalSimple(event) {
    this.flexibleLimitModal(event, {
      title: 'Você chegou ao limite de gabaritos comentados',
      description: 'Você está no ritmo certo para conquistar sua vaga',
      message:
        '<strong>Desbloqueie a solução detalhada</strong> e aprenda o método correto para <strong>resolver essa questão</strong>.',
      resourceType: 'commented feedback',
      ctaUrl:
        '/planos-de-assinatura?qtm_source=belt_gabarito_odin&qtm_medium=intervencao&qtm_content=modal_limitacao&qtm_term=produto&qtm_campaign=plg'
    });
  },

  lessonsLimitModalSimple(event) {
    this.flexibleLimitModal(event, {
      title: 'Limite de 1 aula por dia atingido!',
      description: 'Você está no ritmo certo para conquistar sua vaga',
      message:
        'Volte amanhã para ver mais aulas, ou resolva livremente <strong>assinando um plano!</strong>',
      resourceType: 'classes - question belt',
      ctaUrl:
        '/planos-de-assinatura?qtm_source=belt_aulas_odin&qtm_medium=intervencao&qtm_content=modal_limitacao&qtm_term=produto&qtm_campaign=plg'
    });
  },

  _sendAnalytics(data = {}) {
    const $bodyEl = $('body');

    let eventData = data;

    if ($bodyEl.hasClass('q-route-questions-show')) {
      eventData = {
        ...eventData,
        source_page: 'show'
      };
    }

    UserTracker.emit('event', {
      eventName: 'account limit reached',
      data: eventData
    });
  }
};

export default feedbacks;
